import React from "react";
// import PropTypes from "prop-types";
// import { AutoComplete } from "antd";

class Autocomplete extends React.Component {
    render() {
        return "this will render the autocomplete";
    }
}

export default Autocomplete;
